import axios from 'axios';
import { errorHandler, requestHandler } from './interceptors';
import { getCurrentLanguage } from 'utils/getCurrentLanguage';
export const { REACT_APP_API_URL } = process.env;

export const api = axios.create({
  baseURL: REACT_APP_API_URL
});

api.defaults.headers['Accept-Language'] = getCurrentLanguage()
api.interceptors.request.use(config => requestHandler(config));
api.interceptors.response.use(
  _ => _,
  error => errorHandler(error)
);
